module.exports = {
	"permanent": "永久",
	"buttons": {
		"cancel": "キャンセル",
		"close": "閉じる",
		"copy": "コピー",
		"copyFile": "ファイルをコピー",
		"copyToClipboard": "クリップボードにコピー",
		"create": "作成",
		"delete": "削除",
		"download": "ダウンロード",
		"info": "情報",
		"more": "More",
		"move": "移動",
		"moveFile": "ファイルを移動",
		"new": "新規",
		"next": "次",
		"ok": "OK",
		"replace": "置き換える",
		"previous": "前",
		"rename": "名前を変更",
		"reportIssue": "問題を報告",
		"save": "保存",
		"search": "検索",
		"select": "選択",
		"share": "シェア",
		"publish": "発表",
		"selectMultiple": "複数選択",
		"schedule": "スケジュール",
		"switchView": "表示を切り替わる",
		"toggleSidebar": "サイドバーを表示する",
		"update": "更新",
		"upload": "アップロード",
		"permalink": "固定リンク"
	},
	"success": {
		"linkCopied": "リンクがコピーされました！"
	},
	"errors": {
		"forbidden": "アクセスが拒否されました。",
		"internal": "内部エラーが発生しました。",
		"notFound": "リソースが見つからなりませんでした。"
	},
	"files": {
		"folders": "フォルダ",
		"files": "ファイル",
		"body": "本文",
		"clear": "クリアー",
		"closePreview": "プレビューを閉じる",
		"home": "ホーム",
		"lastModified": "最終変更",
		"loading": "ローディング...",
		"lonely": "ここには何もない...",
		"metadata": "メタデータ",
		"multipleSelectionEnabled": "複数選択有効",
		"name": "名前",
		"size": "サイズ",
		"sortByName": "名前によるソート",
		"sortBySize": "サイズによるソート",
		"sortByLastModified": "最終変更日付によるソート"
	},
	"help": {
		"click": "ファイルやディレクトリを選択",
		"ctrl": {
			"click": "複数のファイルやディレクトリを選択",
			"f": "検索を有効にする",
			"s": "ファイルを保存またはカレントディレクトリをダウンロード"
		},
		"del": "選択した項目を削除",
		"doubleClick": "ファイルやディレクトリをオープン",
		"esc": "選択をクリアーまたはプロンプトを閉じる",
		"f1": "このヘルプを表示",
		"f2": "ファイルの名前を変更",
		"help": "ヘルプ"
	},
	"login": {
		"password": "パスワード",
		"submit": "ログイン",
		"username": "ユーザ名",
		"wrongCredentials": "ユーザ名またはパスワードが間違っています。"
	},
	"prompts": {
		"copy": "コピー",
		"copyMessage": "コピーの目標ディレクトリを選択してください：",
		"currentlyNavigating": "現在閲覧しているディレクトリ：",
		"deleteMessageMultiple": "{count} つのファイルを本当に削除してよろしいですか。",
		"deleteMessageSingle": "このファイル/フォルダを本当に削除してよろしいですか。",
		"deleteTitle": "ファイルを削除",
		"displayName": "名前：",
		"download": "ファイルをダウンロード",
		"downloadMessage": "圧縮形式を選択してください。",
		"error": "あるエラーが発生しました。",
		"fileInfo": "ファイル情報",
		"filesSelected": "{count} つのファイルは選択されました。",
		"lastModified": "最終変更",
		"move": "移動",
		"moveMessage": "移動の目標ディレクトリを選択してください：",
		"newDir": "新しいディレクトリを作成",
		"newDirMessage": "新しいディレクトリの名前を入力してください。",
		"newFile": "新しいファイルを作成",
		"newFileMessage": "新しいファイルの名前を入力してください。",
		"numberDirs": "ディレクトリ個数",
		"numberFiles": "ファイル個数",
		"replace": "置き換える",
		"replaceMessage": "アップロードするファイルの中でかち合う名前が一つあります。 既存のファイルを置き換えりませんか。\n",
		"rename": "名前を変更",
		"renameMessage": "名前を変更しようファイルは：",
		"show": "表示",
		"size": "サイズ",
		"schedule": "スケジュール",
		"scheduleMessage": "このポストの発表日付をスケジュールしてください。",
		"newArchetype": "ある元型に基づいて新しいポストを作成します。ファイルは  コンテンツフォルダに作成されます。"
	},
	"settings": {
		"admin": "管理者",
		"administrator": "管理者",
		"allowCommands": "コマンドの実行",
		"allowEdit": "ファイルやディレクトリの編集、名前変更と削除",
		"allowNew": "ファイルとディレクトリの作成",
		"allowPublish": "ポストとぺーじの発表",
		"avoidChanges": "(変更を避けるために空白にしてください)",
		"changePassword": "パスワードを変更",
		"commands": "コマンド",
		"commandsHelp": "ここで、名前付きイベントに実行するコマンドを設定することができます。一行にコマンド一つを入力してください。イベントはファイルに関連する場合、例えばファイル保存の前にまたは後で、環境変数 FILE はファイルのパスに割り当てられます。",
		"commandsUpdated": "コマンドは更新されました！",
		"customStylesheet": "カスタムスタイルシ ート",
		"examples": "例",
		"globalSettings": "グローバル設定",
		"language": "言語",
		"lockPassword": "新しいパスワードを変更に禁止",
		"newPassword": "新しいパスワード",
		"newPasswordConfirm": "新しいパスワードを確認します",
		"newUser": "新しいユーザー",
		"password": "パスワード",
		"passwordUpdated": "パスワードは更新されました！",
		"permissions": "権限",
		"permissionsHelp": "あなたはユーザーを管理者に設定し、または権限を個々に設定しできます。\"管理者\"を選択する場合、その他のすべての選択肢は自動的に設定されます。ユーザーの管理は管理者の権限として保留されました。",
		"profileSettings": "プロファイル設定",
		"ruleExample1": "各フォルダに名前はドットで始まるファイル（例えば、.git、.gitignore）へのアクセスを制限します。",
		"ruleExample2": "範囲のルートパスに名前は Caddyfile のファイルへのアクセスを制限します。",
		"rules": "規則",
		"rulesHelp1": "ここに、あなたはこのユーザーの許可または拒否規則を設定できます。ブロックされたファイルはリストに表示されません、それではアクセスも制限されます。正規表現(regex)のサポートと範囲に相対のパスが提供されています。",
		"rulesHelp2": "一行に規則一つを入力してください、その間に規則はキーワード {0} や {1} で始める必要があります。そして正規表現を使う場合、{2} と入力し、表現やパスを入力してください。",
		"scope": "範囲",
		"settingsUpdated": "設定は更新されました！",
		"user": "ユーザー",
		"userCommands": "ユーザーのコマンド",
		"userCommandsHelp": "空白区切りの有効のコマンドのリストを指定してください。例：",
		"userCreated": "ユーザーは作成されました！",
		"userDeleted": "ユーザーは削除されました！",
		"userManagement": "ユーザー管理",
		"username": "ユーザー名",
		"users": "ユーザー",
		"userUpdated": "ユーザーは更新されました！"
	},
	"sidebar": {
		"help": "ヘルプ",
		"logout": "ログアウト",
		"myFiles": "私のファイル",
		"newFile": "新しいファイルを作成",
		"newFolder": "新しいフォルダを作成",
		"settings": "設定",
		"siteSettings": "サイト設定",
		"hugoNew": "Hugo New",
		"preview": "プレビュー"
	},
	"search": {
		"images": "画像",
		"music": "音楽",
		"pdf": "PDF",
		"pressToExecute": "Enter を押して実行します。",
		"pressToSearch": "Enter を押して検索します。",
		"search": "検索...",
		"searchOrCommand": "コマンドを検索または実行します。",
		"searchOrSupportedCommand": "サポートしているコマンドを検索または実行します：",
		"type": "キーワードを入力し、Enter を押して検索します。",
		"types": "種類",
		"video": "ビデオ",
		"writeToSearch": "ここにキーワードを入力してください"
	},
	"languages": {
		"en": "English",
		"fr": "Français",
		"pt": "Português",
		"ja": "日本語",
		"zhCN": "中文 (简体)",
		"zhTW": "中文 (繁體)",
		"es": "Español",
		"de": "Deutsch"
	},
	"time": {
		"unit": "時間単位",
		"seconds": "秒",
		"minutes": "分",
		"hours": "時間",
		"days": "日"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ja.yaml
// module id = 289
// module chunks = 0